import { useMemo, useRef } from "react";

import { useFilters } from "@hooks/useFiltersQuery";
import { adaptFiltersForDisplay } from "@hooks/useFiltersQuery/utils";

import { useAppSelector } from "@store/hooks";
import { getCatalogueFilters } from "@store/selectors/getCatalogueSelector";
import { getAvailableTagsSelector, getTagsSelector, isLoadingFilters } from "@store/selectors/getFiltersSelector";

import { getInitialValues, valuesAdapter } from "@components/FilterDialog/utils";
import groupBy from "lodash/groupBy";

type TUseFiltersData = (item: string[]) => void;

export const useFiltersData = (handleSetFilters: TUseFiltersData) => {
  const { handleSetQuery, query } = useFilters();

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const isLoading = useAppSelector(isLoadingFilters);
  const tagsState = useAppSelector(getTagsSelector);
  const availableTags = useAppSelector(getAvailableTagsSelector);

  const dataFilters = useAppSelector(getCatalogueFilters);

  const uniqueTags = useMemo(() => Object.entries(groupBy(tagsState, "tagTypeId.name")), [tagsState.length]);

  const maxLength = dataFilters.maxLength ?? 0;
  const maxBpm = dataFilters.maxBpm ?? 0;

  const initialValues = useMemo(() => {
    return getInitialValues(query);
  }, [maxLength, maxBpm, query]);

  const handleSubmit = (values: any) => {
    const adaptedValues = valuesAdapter(values, query, initialValues);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(async () => {
      const tempAdaptedValues = { ...adaptedValues };
      delete tempAdaptedValues.isAlbumsTab;

      handleSetQuery(tempAdaptedValues);
    }, 1000);

    handleSetFilters(adaptFiltersForDisplay(adaptedValues, tagsState));
  };

  return { dataFilters, initialValues, handleSubmit, maxBpm, maxLength, uniqueTags, availableTags, isLoading };
};
